import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ServiceCard = ({ service, index = 0 }) => {
  return (
    <Link
      to={`/services/${service.id}`}
      data-testid={`service-card-${service.id}`}
      className="group relative block overflow-hidden rounded-3xl bg-secondary aspect-[4/5] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <img
        src={service.image}
        alt={service.title}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
      <div className="absolute top-5 right-5 flex h-11 w-11 items-center justify-center rounded-full bg-background/95 text-foreground opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition duration-500">
        <ArrowUpRight className="h-5 w-5" />
      </div>
      <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8 text-white">
        <p className="text-[10px] uppercase tracking-[0.28em] text-white/80 mb-2">
          Service
        </p>
        <h3 className="font-heading text-2xl sm:text-3xl font-medium leading-tight">
          {service.title}
        </h3>
        <p className="mt-2 text-sm text-white/85 max-w-xs">{service.tagline}</p>
      </div>
    </Link>
  );
};

export default ServiceCard;
